let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("4lrTa")]).then(() => parcelRequire('7sMSo'));